//@ts-ignore
import { ApiClient } from "lib/ApiClient";
import { useGenericSWR } from "lib/useGenericSWR";
import { UserEventLogFilter } from "./UserActivityLogPage.interfaces";

const apiEndpoint = 'api/v1/admin/uc/UserEventLogs';

let formIteration = 0;

const getUserEventLogsDefaultItem = () => {
    formIteration = formIteration + 1;
    return {
        formIteration: "new" + formIteration,
        id: 0,
        eventType: "",
        email: "",
        startDate: "",
        endDate: ""
    }
};

const apiClient = new ApiClient();
apiClient.getDefaultItem = () => getUserEventLogsDefaultItem();
apiClient.getObjectName = () => {
    return "User Event Logs";
};

const useUserEventLogs = (filter: UserEventLogFilter, swrOptions = {}) => {
    const params = new URLSearchParams();

    if (filter.email) params.append('email', encodeURIComponent(filter.email));
    if (filter.eventType) params.append('eventType', filter.eventType);
    if (filter.startDate) params.append('startDate', filter.startDate);
    if (filter.endDate) params.append('endDate', filter.endDate);

    const queryString = params.toString();
    const url = (filter.email || filter.eventType) ? apiEndpoint + '?' + queryString : "";

    return useGenericSWR(url, apiClient, { ...swrOptions });
};

export {
    useUserEventLogs,
    getUserEventLogsDefaultItem
};